export default "__VITE_ASSET__15S6vben__"